<div class="modal-header">
  <div class="header-content">
    <h5 class="modal-title">Detalles del préstamo</h5>
    <div class="d-flex justify-content-start align-items-center">
      <span class="badge badge-info mr-2">{{prestamo?.numeroPrestamo}}</span>
      <span class="text-info">{{prestamo?.alias}}</span>
    </div>
  </div>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cancelar')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ul class="list-group">
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Moneda</span>
      <span class="list-value">{{prestamo?.moneda}}</span>
    </li>
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Valor para estar al día</span>
      <span class="list-value">{{prestamo?.valorParaEstarAlDia | currency}}</span>
    </li>
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Saldo Actual</span>
      <span class="list-value">{{prestamo?.saldoActual| currency}}</span>
    </li>
  </ul>
</div>
